import { type ChangeEvent, useCallback, useRef } from "react";

interface UseFileDialogOptions {
    onFilesSelected: (files: File[]) => void;
}

export const useFileDialog = ({ onFilesSelected }: UseFileDialogOptions) => {
    const fileInputRef = useRef<HTMLInputElement>(null);

    const open = useCallback(() => {
        fileInputRef.current?.click();
    }, [fileInputRef]);

    const onChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
        if (!event.target.files) {
            return;
        }

        const selectedFiles = Array.from(event.target.files);

        onFilesSelected(selectedFiles);

        fileInputRef.current!.value = "";
    }, [onFilesSelected]);

    return {
        fileInputRef,
        open,
        onChange
    };
};
